module.exports = __webpack_public_path__ + "assets/img/logotipo_detecfinder.a54161a2.png";